import { Slider } from 'components/slider'

const slideImages = [...Array(6)].map((_, index) =>
  require(`../../assets/costume/${index + 1}.jpg`)
)

export const SliderCostume = () => (
  <Slider
    maximumWidth={564}
    aspectRatio="1"
    slides={[
      {
        src: slideImages[0],
        title: 'Подвеска в косу',
        description: 'Конец XIX века. Сердолик, серебро',
        note: 'Фото: Российский Этнографический музей',
      },
      {
        src: slideImages[1],
        title: 'Бляха',
        description: 'Конец XIX века. Бирюза, стекло, металл, серебро',
        note: 'Фото: Российский Этнографический музей',
      },
      {
        src: slideImages[2],
        title: 'Футляр для молитвы',
        description: 'Конец XIX века. Стекло, серебро',
        note: 'Фото: Российский Этнографический музей',
      },
      {
        src: slideImages[3],
        title: 'Тюбетейка',
        description: 'Середина XIX века. Позумент, шелк, бархат, золотные нити',
        note: 'Фото: Российский Этнографический музей',
      },
      {
        src: slideImages[4],
        title: 'Украшение наплечно-нагрудное',
        description: 'Конец XIX века. Аметист, бирюза, сердолик, шелк, серебро',
        note: 'Фото: Российский Этнографический музей',
      },
      {
        src: slideImages[5],
        title: 'Украшение шейно-нагрудное',
        description:
          'Конец XIX века. Бирюза, аметист, хрусталь горный, серебро',
        note: 'Фото: Российский Этнографический музей',
      },
    ]}
  />
)
